import React, { createContext, useContext } from "react"

// True while the user is placing voyage-planner points on the map: GIS layers
// then go non-interactive so a click sets the point instead of opening a popup.
const GisSuppressedContext = createContext(false)

export function GisInteractivityProvider({ suppressed, children }) {
  return (
    <GisSuppressedContext.Provider value={suppressed}>
      {children}
    </GisSuppressedContext.Provider>
  )
}

export function useGisSuppressed() {
  return useContext(GisSuppressedContext)
}
